import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  IconButton,
  Typography
} from "@material-tailwind/react";
import {useContext, useEffect, useState} from "react";
import "../../../style/datePicker.css"
import {BranchGrid} from "./branch_grid";
import {BsBoxArrowDownRight} from "react-icons/bs";
import {AgentDisplayDetails} from "./display_details";
import {AgentsForm} from "./form";
import {AgentRequestContext} from "../../../context/agent_context";
import {getAgentRequestInfo} from "../../../services/agent/agent_request";
import {getAgentLog} from "../../../services/agent/agent_log";
import {updateAgentDisplayDetail} from "../../../services/agent/agent";
import {updateBackOfficeAgentRequestPersonalInfo} from "../../../services/back_office/agent";

export function AgentsDialog() {

  const {
    agentId,
    agentRequest,
    setAgentRequest,
    agentLog,
    setAgentLog,
    agentDisplayDetails,
    setAgentDisplayDetails,
    setAgentBranchList,
    setRequestBranchListNew,
    confirmationComments,
    lastDataRefresh,
    setLastDataRefresh,
    modalOpen,
    setModalOpen
  } = useContext(AgentRequestContext)

  const [show, setShow] = useState(2);
  const [saving, setSaving] = useState(false);
  const selectedPersonId = agentRequest?.person_id ?? agentRequest?.user_id;

  const handleShow = (value) => {
    setShow(show === value ? 0 : value);
  }

  const handleOpen = () => setModalOpen(!modalOpen);

  const saveAgentDetails = async () => {
    if (!agentRequest?.id || !selectedPersonId) {
      return;
    }

    setSaving(true);

    try {
      const personalInfoResult = await updateBackOfficeAgentRequestPersonalInfo({
        id: agentRequest.id,
        person_id: selectedPersonId,
        name: agentRequest.name,
        family: agentRequest.family,
        father_name: agentRequest.father_name,
        national_code: agentRequest.national_code,
        birth_date: agentRequest.birth_date,
        gender: agentRequest.gender,
      });

      if (personalInfoResult.status !== 200) {
        return;
      }

      const displayDetailsResult = await updateAgentDisplayDetail({
        agent_id: agentId,
        ...agentDisplayDetails,
      });

      if (displayDetailsResult.status === 200) {
        setLastDataRefresh(Date.now());
      }
    } finally {
      setSaving(false);
    }
  };

  async function getData(id) {
    const result = await getAgentRequestInfo(id);
    if (result.status === 200) {
      const {agent_request_info, agent_log, agent_display_detail, request_branch_list, agent_branch_list} = result.data;
      setAgentRequest(agent_request_info || []);
      setRequestBranchListNew((request_branch_list) || [])
      setAgentBranchList(agent_branch_list || []);
      setAgentDisplayDetails(agent_display_detail);
      setAgentLog(agent_log);
    }

  }

  useEffect(() => {
    if (agentId) {
      getData(agentId);
    }
  }, [agentId, lastDataRefresh]);

  return (
    <>
      <Dialog className="z-10 flex h-[90vh] max-h-[95vh] flex-col overflow-hidden"
              size="lg"
              open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b justify-between">
          <Typography>بررسی‌ اطلاعات ‌مشاور</Typography>
          <div className="flex gap-4">
            <IconButton variant="text" className="rounded-full" onClick={handleOpen}>
              <i className="far fa-times-circle" style={{fontSize: "36px"}}/>
            </IconButton>
          </div>
        </DialogHeader>
        <DialogBody className="min-h-0 flex-1 overflow-y-auto overflow-x-auto">

          <Accordion open={show === 1}>
            <AccordionHeader
              className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl hover:bg-blue-50"
              onClick={() => handleShow(1)}>
              <Typography className="flex w-full font-bold text-lg">
                اطلاعات‌مشاور
              </Typography>
              <BsBoxArrowDownRight className="flex"/>
            </AccordionHeader>
            <AccordionBody>
              <AgentsForm />
            </AccordionBody>
          </Accordion>

          <Accordion className="pt-4" open={show === 2}>
            <AccordionHeader
              className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl  hover:bg-blue-50"
              onClick={() => handleShow(2)}>
              <Typography className="flex w-full font-bold text-lg">
                گرایشات‌درخواست‌مشاور
              </Typography>
              <BsBoxArrowDownRight className="flex"/>
            </AccordionHeader>
            <AccordionBody>
              <BranchGrid />
            </AccordionBody>
          </Accordion>

          <Accordion className="pt-4" open={show === 3}>
            <AccordionHeader
              className="flex flex-row justify-between px-2 border bg-blue-gray-50 rounded-t-2xl  hover:bg-blue-50"
              onClick={() => handleShow(3)}>
              <Typography className="flex w-full font-bold text-lg">
                اطلاعات نمایشی
              </Typography>
              <BsBoxArrowDownRight className="flex"/>
            </AccordionHeader>
            <AccordionBody>
              <AgentDisplayDetails />
            </AccordionBody>
          </Accordion>

        </DialogBody>
        <DialogFooter className="shrink-0 border-t border-blue-gray-100 bg-white">
          <Button
            onClick={saveAgentDetails}
            disabled={saving || !agentRequest?.id || !selectedPersonId}
          >
            {saving ? "در حال ذخیره…" : "ذخیره اطلاعات"}
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}
